<template>
<div class="width-100 mdc-textfield mdc-textfield--upgraded">
	<input class="mdc-textfield__input" ref="input" @input="updateValue($event.target.value)" :type="inputType" :value="value" :placeholder="''" :class="{'input--focus' : value !== '' && greenBorder}">
	<label class="mdc-textfield__label mdc-textfield__label--float-above">{{ placeholder }}</label>
	<a v-if="value !== ''" href="#" class="input__closebtn" @click.prevent="clear"></a>
</div>
</template>

<script>
export default {
	props: {
		greenBorder: {
			type: Boolean,
			default: false
		},
		value: String,
		inputType: {
			type: String,
			default: 'text'
		},
		placeholder: String
	},
	methods: {
		updateValue: function(value) {
			this.$emit('input', value);
		},
		clear: function() {
			this.$refs.input.value = '';
			this.$refs.input.focus();
			this.updateValue(this.$refs.input.value);
		}
	}
}
</script>
